// Pre-translated UI strings (EN + ES). Keep keys flat and stable.
export const STRINGS = {
    en: {
        nav: {
            curriculum: "Curriculum",
            growLab: "Grow Lab",
            waterLab: "Water Lab",
            plantPicker: "Plant Picker",
            teach: "For Teachers",
            about: "The Why",
            dashboard: "Dashboard",
            login: "Log in",
            logout: "Log out",
            signup: "Sign up",
        },
        home: {
            tag: "6-Week Program // Open Source",
            line1: "Grow food.",
            line2_a: "Grow",
            line2_b: "power",
            line3: "on your block.",
            blurb:
                "A 6-week aquaponics curriculum built for inner-city kids and the educators who ride for them. Fish + plants + science + food sovereignty — taught real.",
            startCta: "Start The Program",
            teacherCta: "Teacher Tools",
            sticker_weeks: "6 WEEKS!",
            sticker_science: "science on the block",
            whyTag: "// why this matters",
            whyHead_a: "Built where the",
            whyHead_b: "grocery",
            whyHead_c: "store ain't.",
            whyBody:
                "Over 23 million Americans live in food deserts. We don't wait for the system — we build it. Aquaponics grows 8× more food per square foot using 90% less water than traditional farming. Your rooftop is a farm in waiting.",
            modulesTag: "// 6 modules · self-paced",
            modulesHead_a: "The",
            modulesHead_b: "six weeks",
            modulesSee: "see full curriculum →",
            aiTutorHead: "Ask the Homie — your 24/7 tutor",
            aiTutorBody:
                "Stuck on a quiz? Curious about a fish species? Tap the green button bottom-left and FLOW will break it down in real time. No corny 'educator voice' — just real talk.",
            aiPlanHead: "Teachers: instant lesson plans",
            aiPlanBody:
                "Type a topic and a grade level — get a full, hands-on, culturally-responsive lesson plan in seconds. Powered by Claude.",
            openTeach: "Open Teacher Tools",
        },
        curriculum: {
            tag: "// curriculum · 6 weeks · open",
            head_a: "Pick your",
            head_b: "week",
            blurb:
                "Each module is a 90–120 min session: objectives, activities, vocab, discussion prompts, and a 3-question quiz. Take 'em in order or remix the flow.",
            loading: "loading curriculum…",
        },
        week: {
            back: "all weeks",
            module: "module",
            of: "of",
            objectives: "Learning Objectives",
            activities: "Hands-On Activities",
            materials: "Materials",
            vocab: "Vocabulary",
            discussion: "Discussion Prompts",
            quiz: "Check For Understanding",
            video: "Watch & Learn",
            submit: "Submit Quiz",
            scoring: "Scoring…",
            score: "score",
            perfect: "Perfect run. Bacteria approve.",
            close: "Solid. One re-read and you're locked in.",
            again: "Go back through the module — you got this next time.",
            prev: "Prev Week",
            next: "Next Week",
            done: "Done — back to all modules",
            print: "Print Handout",
            notfound: "404 / week not found",
        },
        teach: {
            tag: "// teacher control room",
            head_a: "Plan a lesson.",
            head_b: "in 20 seconds.",
            blurb:
                "Type a topic. Pick a grade. We'll generate a complete hands-on lesson plan tuned for inner-city classrooms, rooted in aquaponics and food sovereignty. Edit, print, or remix.",
            inputHeader: "INPUT // TEACHER",
            topic: "Topic",
            topicPh: "e.g. the nitrogen cycle",
            grade: "Grade level",
            duration: "Duration (min)",
            style: "Learning style",
            styles: {
                "hands-on": "hands-on lab",
                discussion: "discussion / Socratic",
                "project-based": "project-based",
                "field-trip": "field-trip ready",
            },
            grades: {
                "6-8": "6–8",
                "9-10": "9–10",
                "11-12": "11–12",
                mixed: "mixed (after-school)",
            },
            generating: "Generating…",
            generate: "Generate Plan",
            placeholderHead: "output drops here",
            placeholderBody: "Fill the form and hit",
            cooking: "cooking up your plan…",
            tagReady: "// plan ready",
            copied: "copied",
            copyMd: "copy markdown",
            print: "Print",
        },
        about: {
            tag: "// the why",
            head_a: "Food is",
            head_b: "freedom",
            p1: "FLOW.lab started with a simple question: why are the kids with the most to gain from knowing where their food comes from the ones with the least access to learning it?",
            p2: "Aquaponics isn't just biology. It's chemistry, engineering, business, and community organizing — all flowing through one fish tank. This 6-week curriculum is built to make those connections obvious.",
            h2_a: "How we teach",
            l1: "Real urban examples — from Brooklyn to Detroit to Compton.",
            l2: "Hands-on labs you can run on a $300 budget.",
            l3: "Vocab and discussion that respects how kids already talk.",
            l4: "AI tutoring that sounds like a peer, not a principal.",
            h2_b: "Who it's for",
            p3:
                "Teachers, after-school program leaders, mentors, and kids running their own learning. Free. Forever.",
            quote: '"the future is grown, not bought."',
            quoteBy: "— every kid who finishes the program",
            startW1: "Start week 1",
            teacherTools: "Teachers → tools",
        },
        auth: {
            loginHead: "Log in",
            signupHead: "Sign up",
            email: "Email",
            password: "Password",
            name: "Your name",
            role: "I am a…",
            student: "Student",
            teacher: "Teacher",
            submitLogin: "Log in",
            submitSignup: "Create account",
            switchToSignup: "No account? Sign up",
            switchToLogin: "Have an account? Log in",
            google: "Continue with Google",
            or: "or",
            bad: "Wrong email or password.",
            taken: "That email is already used.",
        },
        dashboard: {
            head: "Teacher Dashboard",
            myPlans: "My Lesson Plans",
            none: "You haven't generated any plans yet.",
            generate: "Generate one →",
            view: "View",
            del: "Delete",
            confirm: "Delete this plan?",
            print: "Print",
            stats: "Stats",
            totalPlans: "Total plans",
            recent: "Most recent topic",
            // Classes
            classes: "My Classes",
            createClass: "Create class",
            createCta: "+ New Class",
            classNamePh: "e.g. Period 3 Bio",
            create: "Create",
            cancel: "Cancel",
            code: "Code",
            students: "Students",
            completion: "Completion",
            noStudents: "No students yet — share the code below.",
            shareCode: "Share this code with your students:",
            copyCode: "Copy code",
            codeCopied: "copied!",
            confirmDelClass: "Delete this class? Students lose access.",
            perWeek: "Per-week averages",
            roster: "Roster",
            studentName: "Student",
            done: "Done",
            avg: "avg",
            rank: "Rank",
            streak: "Streak",
            exportCsv: "Export CSV",
            videoFeedback: "Video feedback",
            noFeedback: "No video feedback yet.",
            pdfDownload: "Download PDF",
            // Watchlist
            watchlistTag: "// tank health watchlist",
            watchlistHead: "Tank Health Watchlist",
            watchlistBlurb: "Classes with flagged readings in the last 7 days.",
            watchlistEmpty: "All tanks clear — no flagged readings this week. 🟢",
            watchlistNoClasses: "Create a class first, then students can share water logs.",
            watchlistIssues: "issues",
            watchlistStudents: "students",
            watchlistLatest: "Latest",
            watchlistView: "Open class →",
        },
        student: {
            head: "Your Dashboard",
            blurb: "Track your weeks, score badges, repeat quizzes.",
            yourWeeks: "Your 6 Weeks",
            badges: "Badges",
            earned: "earned",
            locked: "locked",
            best: "best",
            retake: "Retake",
            start: "Start",
            review: "Review",
            myClasses: "My Classes",
            joinClassHead: "Join a class",
            joinCodePh: "Class code (e.g. AB23XY)",
            join: "Join",
            joined: "Joined!",
            invalid: "Invalid code.",
            totalScore: "Total score",
            weeksDone: "Weeks done",
            badgesEarned: "Badges",
            classRank: "Class rank",
            of: "of",
            streak: "streak",
            reportVideo: "Report this video",
            videoReport: "What's the issue?",
            videoReportPh: "broken link, off-topic, inappropriate, etc.",
            videoSuggest: "Suggest a better URL (optional)",
            videoSubmit: "Send feedback",
            videoThanks: "Thanks — teachers will review.",
            cancel: "Cancel",
            pdfDownload: "Download PDF",
            cheerStreakMine: "weeks in a row 🌟",
            cheerStreakMineOne: "week getting cheered 🌟",
            cheerStreakNone: "No cheer streak yet — finish a week to get on the radar.",
        },
        chat: {
            placeholder: "ask anything…",
            thinking: "thinking…",
            opener:
                "Yo — I'm FLOW, your aquaponics tutor. Ask me anything: fish, plants, the nitrogen cycle, food justice on your block. What's up?",
            askBtn: "Ask the Homie",
            closeBtn: "Close",
            error: "System glitch — try again in a sec.",
        },
        common: {
            loading: "loading…",
        },
    },
    es: {
        nav: {
            curriculum: "Currículo",
            growLab: "Lab de Cultivo",
            waterLab: "Lab de Agua",
            plantPicker: "Elegir Plantas",
            teach: "Maestros",
            about: "El Porqué",
            dashboard: "Panel",
            login: "Entrar",
            logout: "Salir",
            signup: "Registro",
        },
        home: {
            tag: "Programa de 6 Semanas // Código Abierto",
            line1: "Cultiva comida.",
            line2_a: "Cultiva",
            line2_b: "poder",
            line3: "en tu barrio.",
            blurb:
                "Un currículo de acuaponía de 6 semanas para niños urbanos y los educadores que los apoyan. Peces + plantas + ciencia + soberanía alimentaria, enseñado de verdad.",
            startCta: "Empezar el Programa",
            teacherCta: "Herramientas Docentes",
            sticker_weeks: "¡6 SEMANAS!",
            sticker_science: "ciencia en el barrio",
            whyTag: "// por qué importa",
            whyHead_a: "Construido donde no llega",
            whyHead_b: "el súper",
            whyHead_c: "",
            whyBody:
                "Más de 23 millones de personas viven en desiertos alimentarios. No esperamos al sistema — lo construimos. La acuaponía cultiva 8× más comida por metro cuadrado usando 90% menos agua. Tu azotea es una granja esperando.",
            modulesTag: "// 6 módulos · a tu ritmo",
            modulesHead_a: "Las",
            modulesHead_b: "seis semanas",
            modulesSee: "ver currículo completo →",
            aiTutorHead: "Ask the Homie — tu tutor 24/7",
            aiTutorBody:
                "¿Trabado en un quiz? ¿Curioso sobre un pez? Pulsa el botón verde abajo y FLOW te lo explica en tiempo real. Sin voz corporativa — solo plática real.",
            aiPlanHead: "Maestros: planes instantáneos",
            aiPlanBody:
                "Escribe un tema y un nivel — recibe un plan de lección práctico y culturalmente relevante en segundos. Hecho con Claude.",
            openTeach: "Abrir Herramientas",
        },
        curriculum: {
            tag: "// currículo · 6 semanas · abierto",
            head_a: "Elige tu",
            head_b: "semana",
            blurb:
                "Cada módulo dura 90–120 min: objetivos, actividades, vocabulario, preguntas y un quiz de 3 preguntas. Tómalas en orden o remixea.",
            loading: "cargando currículo…",
        },
        week: {
            back: "todas las semanas",
            module: "módulo",
            of: "de",
            objectives: "Objetivos de Aprendizaje",
            activities: "Actividades Prácticas",
            materials: "Materiales",
            vocab: "Vocabulario",
            discussion: "Preguntas de Discusión",
            quiz: "Comprobación",
            video: "Mira y Aprende",
            submit: "Enviar Quiz",
            scoring: "Calificando…",
            score: "puntaje",
            perfect: "¡Perfecto! Las bacterias aprueban.",
            close: "Casi. Una repasada y lo dominas.",
            again: "Repasa el módulo — la próxima va.",
            prev: "Semana Anterior",
            next: "Siguiente Semana",
            done: "Listo — todos los módulos",
            print: "Imprimir Hoja",
            notfound: "404 / semana no encontrada",
        },
        teach: {
            tag: "// sala de control docente",
            head_a: "Planea una lección.",
            head_b: "en 20 segundos.",
            blurb:
                "Escribe un tema. Elige un nivel. Generamos un plan práctico y culturalmente relevante en segundos.",
            inputHeader: "ENTRADA // MAESTRO",
            topic: "Tema",
            topicPh: "ej. el ciclo del nitrógeno",
            grade: "Nivel",
            duration: "Duración (min)",
            style: "Estilo de aprendizaje",
            styles: {
                "hands-on": "laboratorio práctico",
                discussion: "discusión / socrático",
                "project-based": "por proyectos",
                "field-trip": "excursión",
            },
            grades: {
                "6-8": "6º–8º",
                "9-10": "9º–10º",
                "11-12": "11º–12º",
                mixed: "mixto (extracurricular)",
            },
            generating: "Generando…",
            generate: "Generar Plan",
            placeholderHead: "tu plan aparece aquí",
            placeholderBody: "Llena el formulario y pulsa",
            cooking: "preparando tu plan…",
            tagReady: "// plan listo",
            copied: "copiado",
            copyMd: "copiar markdown",
            print: "Imprimir",
        },
        about: {
            tag: "// el porqué",
            head_a: "La comida es",
            head_b: "libertad",
            p1: "FLOW.lab nació de una pregunta simple: ¿por qué los niños que más ganarían con saber de dónde viene su comida son los que menos acceso tienen a aprenderlo?",
            p2: "La acuaponía no es solo biología. Es química, ingeniería, negocios y organización comunitaria — todo fluyendo por un tanque de peces.",
            h2_a: "Cómo enseñamos",
            l1: "Ejemplos urbanos reales — de Brooklyn a Detroit a Compton.",
            l2: "Laboratorios prácticos con $300 de presupuesto.",
            l3: "Vocabulario que respeta cómo hablan los niños.",
            l4: "Tutor IA que suena como un par, no un director.",
            h2_b: "Para quién es",
            p3:
                "Maestros, líderes de programas extracurriculares y niños aprendiendo por su cuenta. Gratis. Para siempre.",
            quote: '"el futuro se cultiva, no se compra."',
            quoteBy: "— cada estudiante que termina",
            startW1: "Empezar semana 1",
            teacherTools: "Maestros → herramientas",
        },
        auth: {
            loginHead: "Entrar",
            signupHead: "Crear cuenta",
            email: "Correo",
            password: "Contraseña",
            name: "Tu nombre",
            role: "Soy…",
            student: "Estudiante",
            teacher: "Maestro/a",
            submitLogin: "Entrar",
            submitSignup: "Crear cuenta",
            switchToSignup: "¿Sin cuenta? Regístrate",
            switchToLogin: "¿Ya tienes cuenta? Entra",
            google: "Continuar con Google",
            or: "o",
            bad: "Correo o contraseña incorrectos.",
            taken: "Ese correo ya está registrado.",
        },
        dashboard: {
            head: "Panel del Maestro",
            myPlans: "Mis Planes",
            none: "Aún no has generado planes.",
            generate: "Generar uno →",
            view: "Ver",
            del: "Borrar",
            confirm: "¿Borrar este plan?",
            print: "Imprimir",
            stats: "Estadísticas",
            totalPlans: "Planes totales",
            recent: "Tema más reciente",
            classes: "Mis Clases",
            createClass: "Crear clase",
            createCta: "+ Nueva Clase",
            classNamePh: "ej. Período 3 Bio",
            create: "Crear",
            cancel: "Cancelar",
            code: "Código",
            students: "Estudiantes",
            completion: "Completado",
            noStudents: "Sin estudiantes — comparte el código.",
            shareCode: "Comparte este código:",
            copyCode: "Copiar",
            codeCopied: "¡copiado!",
            confirmDelClass: "¿Borrar clase? Los estudiantes pierden acceso.",
            perWeek: "Promedio por semana",
            roster: "Lista",
            studentName: "Estudiante",
            done: "Hecho",
            avg: "prom",
            rank: "Rango",
            streak: "Racha",
            exportCsv: "Exportar CSV",
            videoFeedback: "Reportes de video",
            noFeedback: "Sin reportes aún.",
            pdfDownload: "Descargar PDF",
            watchlistTag: "// vigilancia de tanques",
            watchlistHead: "Vigilancia de Tanques",
            watchlistBlurb: "Clases con lecturas marcadas en los últimos 7 días.",
            watchlistEmpty: "Todos los tanques limpios — sin alertas esta semana. 🟢",
            watchlistNoClasses: "Crea una clase primero para que los estudiantes compartan lecturas.",
            watchlistIssues: "alertas",
            watchlistStudents: "estudiantes",
            watchlistLatest: "Última",
            watchlistView: "Abrir clase →",
        },
        student: {
            head: "Tu Panel",
            blurb: "Sigue tus semanas, gana insignias, repite quizzes.",
            yourWeeks: "Tus 6 Semanas",
            badges: "Insignias",
            earned: "ganada",
            locked: "bloqueada",
            best: "mejor",
            retake: "Repetir",
            start: "Empezar",
            review: "Revisar",
            myClasses: "Mis Clases",
            joinClassHead: "Únete a una clase",
            joinCodePh: "Código (ej. AB23XY)",
            join: "Unirse",
            joined: "¡Listo!",
            invalid: "Código inválido.",
            totalScore: "Puntaje total",
            weeksDone: "Semanas hechas",
            badgesEarned: "Insignias",
            classRank: "Tu rango",
            of: "de",
            streak: "racha",
            reportVideo: "Reportar este video",
            videoReport: "¿Cuál es el problema?",
            videoReportPh: "enlace roto, fuera de tema, inapropiado...",
            videoSuggest: "Sugiere otro URL (opcional)",
            videoSubmit: "Enviar",
            videoThanks: "¡Gracias! Los maestros lo revisarán.",
            cancel: "Cancelar",
            pdfDownload: "Descargar PDF",
            cheerStreakMine: "semanas seguidas 🌟",
            cheerStreakMineOne: "semana recibiendo apoyo 🌟",
            cheerStreakNone: "Sin racha aún — termina una semana para subir al radar.",
        },
        chat: {
            placeholder: "pregunta lo que sea…",
            thinking: "pensando…",
            opener:
                "Hola — soy FLOW, tu tutor de acuaponía. Pregúntame de todo: peces, plantas, ciclo del nitrógeno, justicia alimentaria. ¿Qué onda?",
            askBtn: "Ask the Homie",
            closeBtn: "Cerrar",
            error: "Glitch del sistema — intenta de nuevo.",
        },
        common: {
            loading: "cargando…",
        },
    },
};
